import dayjs from 'dayjs'
import { ContractorStatus } from 'src/constants/contractor/enums'

/**
 * `expires_soon` is a sub-state of active, and the `Expires in` column already carries that
 * urgency — showing it again as a status would say the same thing twice, in two visual languages.
 * The priority-queue endpoints already send only `active`/`deactivated`; this stays as a defensive
 * collapse at the render boundary rather than trusting that never changes.
 */
export const getDisplayStatus = (status: ContractorStatus): ContractorStatus => {
  if (status === ContractorStatus.ExpiresSoon) {
    return ContractorStatus.Active
  }

  return status
}

/**
 * Days from today until `date`. Negative means already expired.
 *
 * Everything on the screen — chips, the grid, the "Expires" filter — is derived from this single
 * function, so day 0 is defined in exactly one place.
 */
export const getDaysLeft = (date: string): number => {
  return dayjs(date).startOf('day').diff(dayjs().startOf('day'), 'day')
}

/** Days since `date`. Used for "N days ago" on a logged contact. */
export const getDaysAgo = (date: string): number => {
  return dayjs().startOf('day').diff(dayjs(date).startOf('day'), 'day')
}
